import { cartManager } from "@/utilities";
import { checkforAutoCoupon } from "@/utilities/helper";
export default {
  name: "coupon mixin",
  methods: {
    onSubmitAutoCoupon() {
      let self = this;
      cartManager.generateCouponObject(this.newCart).then((coupon) => {
        cartManager
          .postVerifyCoupon(coupon)
          .then((result) => {
            if (result.coupon) {
              this.newCart.coupon_result = result;
              this.newCart.coupon_error = null;

              cartManager.setCart(this.newCart, true, true);
              self.$notify({
                group: "bottomRight",
                title: this.$t('message.coupon_notify_title'),
                type: "success",
                text: this.$t('message.autocoupon_notify_message', { coupon_name: this.newCart.coupon })
              });
            }
          })
          .catch((e) => {
            this.captureException(e)
          });
      });
    },

    onSubmitCoupon(autoCoupon, showNotification = false) {

      return new Promise((resolve) => {
        if (this.user && this.newCart.coupon && this.newCart.order.length) {
          let self = this;
          cartManager.generateCouponObject(this.newCart).then((coupon) => {
            cartManager
              .postVerifyCoupon(coupon)
              .then((result) => {
                if (result.coupon) {

                  if(result.discountAmount == 0){
                    this.newCart.coupon_result = null;
                    this.newCart.coupon_error = null;
                    showNotification = false;
                  }else{
                    this.newCart.coupon_result = result;
                    this.newCart.coupon_error = null;
                  }

                 

                  if (showNotification) {
                    self.$notify({
                      group: "bottomRight",
                      title: this.$t("message.coupon_notify_title"),
                      type: "success",
                      text: this.$t("message.coupon_notify_message", {
                        coupon_name: this.newCart.coupon,
                      }),
                    });
                  }

                  cartManager.setCart(this.newCart, true, false);
                  resolve({ valid: true, auto: autoCoupon });
                } else {
                  this.newCart.coupon_result = null;
                  this.newCart.coupon_error = result;

                  cartManager.setCart(this.newCart, true, false);

                  //-- display a message that the provided error only if it's not an auto-coupon
                  this.$nextTick(() => {
                    if (autoCoupon) {
                      cartManager.setCart(this.newCart, true, false);
                      resolve({ valid: true, auto: autoCoupon });
                    } else {
                      //--> is not autoCoupon
                      if (showNotification) {
                        self.$notify({
                          group: "bottomRight",
                          title: this.$t("message.coupon_not_valid_notify_title"),
                          type: "danger",
                          text:
                            result.error && result.error.message
                              ? result.error.message
                              : this.$t(
                                "message.coupon_not_valid_notify_message",
                                { coupon_name: this.newCart.coupon }
                              ),
                        });
                      }

                      //--- apply the auto-coupon if any
                      if (!this.newCart.coupon_result) {
                        let autoCouponFound = checkforAutoCoupon(
                          this.selectedLocation
                        );
                        this.newCart.coupon = autoCouponFound
                          ? autoCouponFound.code
                          : "";
                        if (this.newCart.coupon.length) {
                          resolve(this.onSubmitCoupon(true));
                        } else {
                          resolve({ valid: false, auto: autoCoupon });
                        }
                      }
                    }
                  });
                }
              })
              .catch((e) => {

                this.newCart.coupon_result = null;
                this.newCart.coupon_error = e.data;

                self.$notify({
                  group: "bottomRight",
                  title: this.$t("message.coupon_not_valid_notify_title"),
                  type: "danger",
                  text: e.data?.errors && e.data?.errors?.coupon?.length ? e.data.errors.coupon[0] : e.data.message,
                });
                cartManager.setCart(this.newCart, true, false);
                this.$nextTick(() => {
                  if (autoCoupon) {
                    cartManager.setCart(this.newCart, true, false);
                    resolve({ valid: true, auto: autoCoupon });
                  }
                  //--- apply the auto-coupon if any
                  if (!this.newCart.coupon_result) {
                    let autoCouponFound = checkforAutoCoupon(
                      this.selectedLocation
                    );
                    this.newCart.coupon = autoCouponFound
                      ? autoCouponFound.code
                      : "";
                    if (this.newCart.coupon.length) {
                      resolve(this.onSubmitCoupon(true, false));
                    } else {
                      resolve({ valid: false, auto: autoCoupon });
                    }
                  }
                });
              });
          });
        } else {
          resolve({ valid: true, auto: autoCoupon });
        }
      });
    },
  }
}